import Index from "../../pages/sakura/info/index";

const base = "info";

const routes = [
    {
        path: `/${base}/index`,
        name: `${base}-index`,
        component: Index
    },
    {
        path: `/${base}/enter*`,
        name: `${base}-enter`,
        component: Index
    }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/sakura/info.js